import { render } from "./VariantLabel.vue?vue&type=template&id=0b89e850&scoped=true"
import script from "./VariantLabel.vue?vue&type=script&lang=js"
export * from "./VariantLabel.vue?vue&type=script&lang=js"

import "./VariantLabel.vue?vue&type=style&index=0&id=0b89e850&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b89e850"]])

export default __exports__